import React from 'react';
import PropTypes from 'prop-types';
import { CRow, CCol, CCard, CCardBody, CFormSwitch, CFormInput } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSend, cilEnvelopeClosed, cilChatBubble } from '@coreui/icons';

const MessengerSettings = ({ config, updateConfig }) => (
  <CRow className="g-3 align-items-stretch">
    {/* Telegram */}
    <CCol lg={4} md={6}>
      <CCard className={`h-100 shadow-sm border-0 ${config.send_telegram ? 'border-bottom border-bottom-3 border-bottom-info' : ''}`}>
        <CCardBody className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="d-flex align-items-center fw-bold text-dark">
              <CIcon icon={cilSend} className="me-2 text-info" /> Telegram
            </span>
            <CFormSwitch
              id="send_tg"
              checked={config.send_telegram}
              onChange={(e) => updateConfig({ send_telegram: e.target.checked })}
            />
          </div>
          {config.send_telegram ? (
            <div className="mt-2">
              <div className="mb-2 text-muted small bg-light p-2 rounded border" style={{ fontSize: '0.8rem' }}>
                1. Запустите бота <a href="https://t.me/neimarker_alert_bot" target="_blank" rel="noreferrer" className="text-info text-decoration-none">@neimarker_alert_bot</a><br />
                2. Узнайте свой ID, и впишите в поле снизу
              </div>
              <CFormInput
                size="sm"
                placeholder="Ваш Telegram ID"
                value={config.telegram_chat_id || ''}
                onChange={(e) => updateConfig({ telegram_chat_id: e.target.value })}
                className="border-info"
              />
            </div>
          ) : (
            <p className="text-muted small mt-2 mb-0">Уведомления в Telegram отключены.</p>
          )}
        </CCardBody>
      </CCard>
    </CCol>

    {/* Email */}
    <CCol lg={4} md={6}>
      <CCard className={`h-100 shadow-sm border-0 ${config.send_email ? 'border-bottom border-bottom-3 border-bottom-warning' : ''}`}>
        <CCardBody className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="d-flex align-items-center fw-bold text-dark">
              <CIcon icon={cilEnvelopeClosed} className="me-2 text-warning" /> E-Mail
            </span>
            <CFormSwitch
              id="send_email"
              checked={config.send_email}
              onChange={(e) => updateConfig({ send_email: e.target.checked })}
            />
          </div>
          {config.send_email ? (
            <div className="mt-2">
              <div className="mb-2 text-muted small bg-light p-2 rounded border" style={{ fontSize: '0.8rem' }}>
                Укажите адреса. Можно указать несколько через запятую.
              </div>
              <CFormInput
                size="sm"
                placeholder="ceo@mail.ru, ..."
                value={config.emails || ''}
                onChange={(e) => updateConfig({ emails: e.target.value })}
                className="border-warning"
              />
            </div>
          ) : (
            <p className="text-muted small mt-2 mb-0">Email-рассылка отключена.</p>
          )}
        </CCardBody>
      </CCard>
    </CCol>

    {/* MAX Messenger */}
    <CCol lg={4} md={12}>
      <CCard className={`h-100 shadow-sm border-0 ${config.send_max ? 'border-bottom border-bottom-3 border-bottom-success' : ''}`}>
        <CCardBody className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="d-flex align-items-center fw-bold text-dark">
              <CIcon icon={cilChatBubble} className="me-2 text-success" /> Мессенджер MAX
            </span>
            <CFormSwitch
              id="send_max"
              checked={config.send_max}
              onChange={(e) => updateConfig({ send_max: e.target.checked })}
            />
          </div>
          {config.send_max ? (
            <div className="mt-2">
              <div className="mb-2 text-muted small bg-light p-2 rounded border" style={{ fontSize: '0.8rem' }}>
                1. Откройте нашего бота: <a href="https://max.ru/id5260477500_bot" target="_blank" rel="noreferrer" className="text-success text-decoration-none fw-bold">@id5260477500_bot</a><br />
                2. Нажмите кнопку <strong>«Старт»</strong>.<br />
                3. Бот пришлет ваш <strong>ID</strong>.
              </div>
              <CFormInput
                size="sm"
                placeholder="Ваш ID в MAX"
                value={config.max_chat_id || ''}
                onChange={(e) => updateConfig({ max_chat_id: e.target.value })}
                className="border-success fw-bold"
              />
            </div>
          ) : (
            <p className="text-muted small mt-2 mb-0">Уведомления в MAX отключены.</p>
          )}
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
);

MessengerSettings.propTypes = {
  config: PropTypes.object.isRequired,
  updateConfig: PropTypes.func.isRequired,
};

export default MessengerSettings;